import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { ReportsService } from './reports.service';

export const Ng1ReportsModule = angular
  .module('control-room.commons.services.reports', [])
  .factory('crReportsService', downgradeInjectable(ReportsService));
